export default {"src":"/_next/static/media/wishlist_raccoon.61793e5c.svg","height":107,"width":87};